import type { CSSProperties } from 'react';
import { cn } from '@/lib/utils';

/** First letters of the first two words, ignoring anything in brackets:
 * "Ellison (Sizzix)" -> "EL", "Paper Rose Studio" -> "PR". */
function initialsOf(name: string): string {
  const words = name.replace(/\(.*?\)/g, ' ').split(/[\s&/,-]+/).filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/** A stable hue per name, so a vendor is the same colour on every row. */
function hueOf(name: string): number {
  let h = 0;
  for (const ch of name.toLowerCase()) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h % 360;
}

/**
 * Initials badge for a vendor. Purely a visual anchor: it is aria-hidden and
 * the name always appears in text beside it.
 */
export function Monogram({ name, className }: { name: string; className?: string }) {
  return <span aria-hidden="true" className={cn('grid h-8 w-[72px] shrink-0 place-items-center rounded-lg text-[12px] font-bold tracking-[.02em] bg-[oklch(0.93_0.04_var(--mono-hue))] text-[oklch(0.42_0.11_var(--mono-hue))] dark:bg-[oklch(0.36_0.06_var(--mono-hue))] dark:text-[oklch(0.86_0.08_var(--mono-hue))]', className)} style={{ '--mono-hue': hueOf(name) } as CSSProperties}>{initialsOf(name)}</span>;
}
